import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

export default function SearchComponent(props) {
  const router = useRouter();
  const [searchFilter, setsearchFilter] = useState('');

  let { searchQuery: searchQuery } = router.query;

  useEffect(() => {
    if (searchQuery) {
      setsearchFilter(searchQuery);
    } else if (!searchQuery && searchFilter.length > 0) {
      setsearchFilter('');
    }
  }, [searchQuery]);

  return (
    <form
      className="filter__keywords "
      onSubmit={(e) => {
        e.preventDefault();
        props.updateRoute({ searchQuery: searchFilter });
      }}
    >
      <input
        placeholder="Type your keywords"
        value={searchFilter}
        onChange={(e) => setsearchFilter(e.target.value)}
      />
      {searchFilter && searchFilter.length > 0 && (
        <button
          type="button"
          style={{
            right: 70,
          }}
          onClick={() => {
            setsearchFilter('');
            if (searchQuery && searchQuery.length > 0) {
              props.updateRoute(['searchQuery', ''], 'remove');
            }
          }}
          className="close_icon"
        >
          <HighlightOffIcon />
        </button>
      )}{' '}
      <button type="submit">
        <i className="fa fa-search text-lg" aria-hidden="true"></i>
      </button>
    </form>
  );
}
